import { Turbo } from "@hotwired/turbo-rails";

Turbo.session.drive = false;

document.addEventListener("turbo:load", () => {
  // https://bulma.io/documentation/components/navbar/#navbar-menu {{{
  document.querySelectorAll(".navbar-burger").forEach((el) => {
    el.addEventListener("click", () => {
      const targetEl = document.getElementById(el.dataset.target);

      el.classList.toggle("is-active");
      targetEl.classList.toggle("is-active");
    });
  });
  // }}}
});
